import { useMutation, useQueryClient } from '@tanstack/react-query'
import api from '../../api'
import type { MongoDBReopenRequest } from '../../types/mongodb'

const useReopenMongoDB = (mongoDBID: string) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (request: MongoDBReopenRequest) =>
			api.mongodb.reopenMongoDB(request),
		onSuccess: () => {
			void queryClient.invalidateQueries({ queryKey: ['mongodb'], exact: true })
			void queryClient.invalidateQueries({ queryKey: ['mongodb', mongoDBID] })
			void queryClient.invalidateQueries({ queryKey: ['mongodb-eligibility'] })
		}
	})
}

export default useReopenMongoDB
